import { render, staticRenderFns } from "./pluginView.vue?vue&type=template&id=04fa4144&"
import script from "./pluginView.vue?vue&type=script&lang=js&"
export * from "./pluginView.vue?vue&type=script&lang=js&"
import style0 from "./pluginView.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports